<template>
  <div>
    <div class="img-list">
      <div class="img-box g-adaptimg" v-for="(item,index) in imgList" @click="lookimg(index)">
        <img :src="item.url"/>
        <i class="iconfont icon-chahao" @click.stop="delImage(index)"></i>
      </div>
      <div :class="{'upload-box':true,'reUpLoad':isReUp}" v-if="!isWrite" v-show="imgList.length<length">
        <i class="iconfont icon-zengjia"></i>
        <input id="files" type="file" @change="onFileChange" class="upload-input" multiple accept="image/*"/>
      </div>
      <div :class="{'isWrite':true,'reUpLoad':isReUp}" v-if="isWrite" v-show="imgList.length<length">
        <i class="iconfont icon-tupian"></i>
        <input id="files" type="file" @change="onFileChange" class="upload-input" multiple accept="image/*"/>
      </div>
    </div>
    <div class="g-members-choose-box" v-show="isLoading">
      <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  import * as getData from '../service/getData'
  import * as mobile from '../config/mUtils'
  export default {
    data () {
      return {
        isLoading: false
      }
    },
    activated () {

    },
    mounted () {
    },
    props: ['imgList', 'length', 'record', 'isReUp', 'isWrite'],
    methods: {
      onFileChange (e) {
        var files = e.target.files || e.dataTransfer.files;
        var leng = files.length;
        if (!files.length) return;
        if (leng > this.length || this.imgList.length >= this.length) {
          this.isLoading = false;
          mobile.toast('最多上传' + this.length + '张');
          return
        }
        mobile.selectImgFile(e).then(res => {
          if (res.res) {
            this.isLoading = true;
            mobile.uploadOss(e, getData.getSystemOssByUrl).then(res => {
              this.isLoading = false;
              this.imgList.push({url: res.exportFile, fileUrl: files[0], name: res.fileName});
              this.$emit('getImgList', this.imgList)
            }).catch(err=> {
              console.log(err)
            })
          }
        })
        
      },
      createImage (file,e) {
        if (typeof FileReader === 'undefined'){
          alert('您的浏览器不支持图片上传，请升级您的浏览器');
          return false;
        }
        var image = new Image();
        var vm = this;
        var leng = file.length;
        if (leng > this.length || this.imgList.length >= this.length) {
          this.isLoading = false;
          mobile.toast('最多上传' + this.length + '张');
          return
        }
        for (let i = 0; i < leng; i++) {
          var reader = new FileReader();
          reader.readAsDataURL(file[i]);
          reader.onload = function () {
            var image = new Image();
            image.src = this.result;
            image.onload = function () {
              if (file[i].size > 1024 * 1024 * 5) {
                mobile.toast('您上传的图片大于5M，上传失败！');
                document.getElementById('files').value = '';
                vm.isLoading = false;
                return
              }
              mobile.uploadOss(files, getData.getSystemOssByUrl).then(res => {
                vm.isLoading = false;
                vm.imgList.push({url: e, fileUrl: file[0], name: res.fileName});
              }).catch(err=> {
                console.log(err)
              })
            }
          };
        }
        //this.$store.state.imgList = vm.imgList
        this.$emit('getImgList', vm.imgList)
      },
      delImage: function (index) {
        this.imgList.splice(index, 1);
        document.querySelector('input[type=file]').value = '';
        //this.$store.state.imgList = this.imgList;
        this.$emit('getImgList', this.imgList);
      },
      lookimg (index) {
        this.$emit('lookimg', index);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/css/mixin';
  .img-list{
    flex-wrap: wrap;
    display: flex;
    .upload-box{
      @include wh(1.2rem,1.2rem);
      position: relative;
      border: .02rem dashed #bbb;
      border-radius: .04rem;
      margin-bottom: .15rem;
      i{
        @include center;
        @include wh(.44rem,.44rem);
        &:before,&:after{
          content: '';
          background: #bbb;
        }
        &:before{
          @include cl;
          @include wh(.04rem,.44rem);
        }
        &:after{
          @include ct;
          @include wh(.44rem,.04rem);
        }
      }
      .upload-input{
        position: absolute;
        top: 0;
        left: 0;
        @include wh(1.2rem,1.2rem);
        opacity: 0;
      }
      &.reUpLoad{
        background-size: contain;
      }
    }
    .isWrite{
      position: relative;
      margin-bottom: .15rem;
      i{
        @include sc(.8rem,#009DFF);
      }
      .upload-input{
        position: absolute;
        top: 0;
        left: 0;
        @include wh(100%,100%);
        opacity: 0;
      }
    }
    .img-box{
      @include wh(1.2rem,1.2rem);
      margin-right: .26rem;
      margin-bottom: .15rem;
      position: relative;
      i{
        position: absolute;
        font-size: .4rem;
        right: -.2rem;
        top: -.2rem;
      }
    }
  }
  .mask{
    background-color: rgba(0,0,0,1);
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    img{
      @include center();
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }

  .loading {
    @include center;
    display:block;
    width:10vh;
    height:10vh;
    text-align:center;
    filter:contrast(1.2);

    span {
      mix-blend-mode:screen;
      display:block;
      position:absolute;
      border-radius:50%;
      animation:wave 3s infinite linear;
    }

    span:nth-child(0) {
      left:-11%;
      right:-2%;
      top:-12%;
      bottom:-5%;
      transform-origin:46% 53%;
      animation-delay:0;
      background-color:hsl(0, 50%, 50%);
    }

    span:nth-child(1) {
      left:-4%;
      right:-4%;
      top:-9%;
      bottom:-2%;
      transform-origin:47% 50%;
      animation-delay:-1s;
      background-color:hsl(50, 60%, 50%);
    }

    span:nth-child(2) {
      left:-11%;
      right:-4%;
      top:-10%;
      bottom:-11%;
      transform-origin:49% 53%;
      animation-delay:-1.5s;
      background-color:hsl(100, 70%, 50%);
    }

    span:nth-child(3) {
      left:-7%;
      right:-9%;
      top:-11%;
      bottom:-4%;
      transform-origin:47% 52%;
      animation-delay:-2s;
      background-color:hsl(150, 80%, 50%);
    }

    span:nth-child(4) {
      left:-8%;
      right:-3%;
      top:-5%;
      bottom:-11%;
      transform-origin:47% 52%;
      animation-delay:-2.5s;
      background-color:hsl(200, 90%, 50%);
    }

    span:nth-child(5) {
      left:-10%;
      right:-8%;
      top:-4%;
      bottom:-9%;
      transform-origin:48% 51%;
      animation-delay:-3s;
      background-color:hsl(250, 100%, 50%);
    }

    span:nth-child(6) {
      left:-9%;
      right:-11%;
      top:-5%;
      bottom:-8%;
      transform-origin:47% 50%;
      animation-delay:-3.5s;
      background-color:hsl(300, 100%, 50%);
    }
  }

  @keyframes wave {
    from {
      transform:rotateZ(0deg);
    }
    to {
      transform:rotateZ(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// addimg.vue?ee24246e